/* src/app/components/shared/molecules/tabs-block/tabs-block.component.scss */
/*# sourceMappingURL=tabs-block.component-7JKQ55FM.css.map */
